import script from "./Template3.vue?vue&type=script&setup=true&lang=ts"
export * from "./Template3.vue?vue&type=script&setup=true&lang=ts"

import "./Template3.vue?vue&type=style&index=0&id=4bfa6ded&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bfa6ded"]])

export default __exports__